import { createContext } from 'react';

export const AuthenticatedContext = createContext();
